import React from 'react';
import { Helmet } from 'react-helmet-async';

export const AppMetaProvider: React.FC = () => {
  const appId = process.env.REACT_APP_APPLICATION_ID!;

  const titleMap: Record<string, string> = {
    'gat-transport-se': 'Assistansbolaget',
    'gat-transport-dk': 'Assist24',
  };

  const faviconMapper: Record<string, string> = {
    'gat-transport-se': '/favicon_ab.png',
    'gat-transport-dk': '/favicon_assist24.ico',
  };

  const title = titleMap[appId] || 'App';
  const favicon = faviconMapper[appId] || '/favicons/default.ico';

  return (
    <Helmet>
      <title>{title}</title>
      <link rel='icon' type='image/x-icon' href={favicon} />
    </Helmet>
  );
};
